import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { AppLoadingStateModel } from 'src/app/model';
import { StartAppLoading, StopAppLoading } from './app-loading.actions';

@State<AppLoadingStateModel>({
  name: 'appLoading',
  defaults: {
    isAppLoading: false,
  },
})
@Injectable()
export class AppLoadingState {
  @Selector()
  static isAppLoading(state: AppLoadingStateModel): boolean {
    return state.isAppLoading;
  }

  @Action(StartAppLoading)
  startAppLoading({ patchState }: StateContext<AppLoadingStateModel>): void {
    patchState({
      isAppLoading: true,
    });
  }

  @Action(StopAppLoading)
  stopAppLoading({ patchState }: StateContext<AppLoadingStateModel>): void {
    patchState({
      isAppLoading: false,
    });
  }
}
